class SequencerModes {
	static Auto = 1;
	static Manual = 2;
	static LiveAssist = 3;
	static Split = 4;

	static getArray() {
		return Object.keys(this).map((t, i) => {
			return {
				name: t.split(/(?<=[a-z])(?=[A-Z])/).join(" "),
				type: Object.values(this)[i]
			}
		});
	}

	static getName(type) {
		return this.getArray().find(t => t.type === type)?.name;
	}
}

export default SequencerModes;